import { IconFolderTree } from "components/icons";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";

export const IconButtonFolderTree: React.FC<MprcIconButtonProps> = ({ ...rest }) => {
    return (
        <MprcIconButton
            {...rest}
        >
            <IconFolderTree  fixedWidth />
        </MprcIconButton>
    );
};
